import React, { useEffect, useState } from "react";
import Post from "./Post/Post";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroll-component";
import GuestPost from "./Post/GuestPost";
import {useParams} from "react-router-dom";

const GuestHome = () => {
    let { slug } = useParams();
    // console.log(slug)
    const [postInfo,setPostInfo] = useState(null);
    const [posts, setPosts] = useState([]);
    const [paginate, setPaginate] = useState(1);
    const [status, setstatus] = useState(true);
    const [url, setUrl] = useState('');
    const [type, setType] = useState(true);

    const fetchData = async () => {
      if(postInfo != null){

        if((paginate-1) > postInfo.last_page){
          return;
        }
      }

        setUrl('api/guest/all_post/with-paginate/5?page='+paginate);

        const res = await axios.get(url)
        if(res.data.status === 200){
            if (type) {
              setPostInfo(res.data)
              setPosts(res.data.posts);
              setstatus(false);
          } else {
              setPostInfo(res.data)
              setPosts([...posts, ...res.data.posts]);
              setPaginate(paginate + 1);
              setstatus(false);
          }
        }


    };

  useEffect(() => {
      if(slug!==''&&slug!==undefined){
          if(slug){
              setUrl('api/guest/all_post/byid/'+slug);
              setType(true);
              axios.get('api/guest/all_post/byid/'+slug)
                  .then((res) => {
                      if (res.data.status === 200) {
                          setPostInfo(res.data)
                          setPosts(res.data.posts);
                          setstatus(false);
                      }
                  });
          }
      }else{
          setUrl('api/guest/all_post/with-paginate/5?page='+paginate);
          setType(false);
          axios.get('api/guest/all_post/with-paginate/5?page='+paginate)
              .then((res) => {
                  if (res.data.status === 200) {
                      setPostInfo(res.data)
                      setPosts([...posts, ...res.data.posts]);
                      setPaginate(paginate + 1);
                      setstatus(false);
                  }
              });
      }
  }, [slug]);

  return (
    <>
      <InfiniteScroll
        dataLength={posts.length}
        next={fetchData}
        hasMore={true}
        loader={type?<h4 className="text-center text-warning pt-3">Loading...</h4>:<></>}
        endMessage={
          <p style={{ textAlign: "center" }}>
            <b>Looks like you've reached the end of the posts</b>
          </p>
        }
      >

        <GuestPost style={{ minHeight: "30vh" }} posts={posts} status={status} />
      </InfiniteScroll>


    </>
  );
};

export default GuestHome;
